import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AddSite() {
  const allSiteUserAdvertiserConfirm = [
    "https://test-4.ir",
    "https://test-5.ir",
  ];
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن سایت ها نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link className="btn btn-primary" to="/site/all">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="alert alert-warning ">
                <p>
                  <i className="fa fa-info pl-2"></i>شروط اضافه کردن سایت نمایش
                  دهنده :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p>
                      سایت شما باید جز سایت های تبلیغ دهنده و در وضعیت تایید شده
                      باشد.
                    </p>
                  </li>
                  <li>
                    <p>سایت شما باید Responsive باشد.</p>
                  </li>
                  <li>
                    <p> گواهینامه ssl باید در سایت شما فعال باشد.</p>
                  </li>
                </ul>
              </div>
              <div>
                <h4>سایت های تبلیغ دهنده فعال شما</h4>
                <div className="container-fluid pt-2">
                  <div className="row">
                    {allSiteUserAdvertiserConfirm.map((siteUrl) => {
                      return (
                        <div className="col-6">
                          <div className="card">
                            <div className="card-body">
                              <h5 className="card-title text-center">
                                <a href={siteUrl} target="_blank">
                                  {siteUrl}
                                </a>
                              </h5>
                              <div className="card-text text-center pt-2">
                                <ButtonDisable
                                  buttonTagHtml={
                                    <span className="btn btn-success opacity-50">
                                      انتخاب به عنوان نمایش دهنده هایلات
                                    </span>
                                  }
                                ></ButtonDisable>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
